function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M437.333,291.329c-41.173,0-74.667,33.493-74.667,74.667s33.493,74.667,74.667,74.667S512,407.169,512,365.996 S478.507,291.329,437.333,291.329z M437.333,397.996c-17.643,0-32-14.357-32-32s14.357-32,32-32c17.643,0,32,14.357,32,32 S454.976,397.996,437.333,397.996z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M187.477,341.1c-1.493-4.267-5.525-7.104-10.048-7.104h-60.096c17.643,0,32,14.357,32,32s-14.357,32-32,32 c-17.643,0-32-14.357-32-32s14.357-32,32-32H57.259c-4.523,0-8.555,2.837-10.048,7.104c-3.072,8.619-4.544,16.747-4.544,24.896 c0,41.173,33.493,74.667,74.667,74.667c41.173,0,74.667-33.493,74.667-74.667C192,357.846,190.528,349.718,187.477,341.1z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M224,184.662H74.667c-17.643,0-32,14.357-32,32c0,17.643,14.357,32,32,32H224c17.643,0,32-14.357,32-32 C256,199.02,241.643,184.662,224,184.662z"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M334.784,206.806c-5.419-2.24-11.669,0.299-13.952,5.739l-53.333,128c-2.261,5.44,0.299,11.691,5.739,13.952 c1.344,0.576,2.731,0.832,4.096,0.832c4.181,0,8.128-2.475,9.856-6.571l53.333-128 C342.784,215.318,340.224,209.068,334.784,206.806z"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M218.944,273.793c-2.027-2.411-5.013-3.797-8.171-3.797H74.667c-12.395,0-24.171-4.395-34.069-12.715 c-4.331-3.627-10.752-3.264-14.635,0.853c-2.027,2.133-3.925,4.331-5.696,6.485C7.189,280.705,0,301.548,0,323.329 c0,17.643,14.357,32,32,32h170.667c5.547,0,10.176-4.245,10.624-9.771c0.021-0.341,2.901-33.963,8-63.061 C221.824,279.404,220.971,276.204,218.944,273.793z"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M361.493,95.318c-10.709,2.133-17.109,13.163-13.653,23.509l0.043,0.107c2.453,7.403,9.387,12.395,17.195,12.395H384 l10.667-42.667L361.493,95.318z"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M402.389,81.302c-2.539-2.645-6.251-3.819-9.813-3.093l-33.195,6.635c-8.107,1.621-15.125,6.656-19.264,13.803 c-4.139,7.147-5.013,15.723-2.368,23.659c3.925,11.776,14.912,19.691,27.328,19.691H384c4.885,0,9.152-3.328,10.347-8.085 l10.667-42.667C405.909,87.702,404.907,83.948,402.389,81.302z M375.68,120.662h-10.603c-3.221,0-6.08-2.069-7.125-5.227 c-0.939-2.773-0.021-5.013,0.619-6.101c0.619-1.088,2.112-3.008,4.992-3.584l16.661-3.328L375.68,120.662z"
})));

var _ref9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M437.333,248.662c-23.061,0-32.277-24-32.875-25.536l-56.363-131.52c-6.485-15.168-22.763-23.232-38.848-19.264 c-9.003,2.24-16.725,8.213-21.184,16.341c-4.459,8.128-5.355,17.856-2.411,26.667l10.645,31.957l29.184-17.515 c5.077-3.029,11.605-1.387,14.635,3.648c3.029,5.056,1.387,11.605-3.648,14.635l-33.237,19.947l17.323,51.989 c0.405,1.195,1.003,2.304,1.771,3.285l19.115,23.915c9.259,11.563,9.493,27.648,0.597,39.147 c-6.037,7.787-10.901,15.851-14.485,23.957c-4.373,9.92-3.456,21.291,2.496,30.4c5.952,9.131,16,14.592,26.859,14.592h16.427 c5.888,0,10.667-4.779,10.667-10.667c0-2.197-0.811-4.117-1.963-5.803l46.571-31.04c1.856,2.773,4.821,4.757,8.427,4.864 c21.504,0.661,59.307,0,70.315-10.688c3.008-2.923,4.651-6.72,4.651-10.645C512,269.356,469.931,248.662,437.333,248.662z"
})));

var _ref10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M329.131,115.158c-3.029-5.035-9.557-6.699-14.635-3.648l-53.333,32c-5.035,3.029-6.677,9.579-3.648,14.635 c2.005,3.349,5.525,5.184,9.152,5.184c1.877,0,3.776-0.491,5.483-1.536l53.333-32C330.517,126.764,332.16,120.193,329.131,115.158 z"
})));

var _ref11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M277.333,333.996h-74.667c-5.888,0-10.667,4.779-10.667,10.667c0,5.888,4.779,10.667,10.667,10.667h74.667 c5.888,0,10.667-4.779,10.667-10.667C288,338.774,283.221,333.996,277.333,333.996z"
})));

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

var _ref22 = /*#__PURE__*/React.createElement("g", null);

var _ref23 = /*#__PURE__*/React.createElement("g", null);

var _ref24 = /*#__PURE__*/React.createElement("g", null);

var _ref25 = /*#__PURE__*/React.createElement("g", null);

var _ref26 = /*#__PURE__*/React.createElement("g", null);

var SvgScooter = function SvgScooter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScooter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scooter.6db3543a.svg";
export { ForwardRef as ReactComponent };